import { createSlice } from "@reduxjs/toolkit"
import { profileApi } from "./profileApi"

import { type RootState } from "../../app/apis"
import { ProfileUser } from "./models"

type ProfileState = {
  profile: ProfileUser | null
  impersonateMessage?: string
}

const initialState: ProfileState = {
  profile: null,
}

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload
    },
    clearProfile: (state) => {
      state.profile = null
    },
    setImpersonateMessage: (state, action) => {
      state.impersonateMessage = action.payload
    },
  },
  extraReducers: (builder) => {
    // Link profileApi getProfile fulfilled to update profile state
    // @ts-ignore: Type inference for RTK Query matcher
    builder.addMatcher(
      profileApi.endpoints.getProfile.matchFulfilled,
      (state, { payload }) => {
        state.profile = payload?.data
      },
    )
  },
})

export const profileActions = profileSlice.actions

export const selectProfile = (state: RootState) => state.profile.profile
export const selectImpersonateMessage = (state: RootState) =>
  state.profile.impersonateMessage
